import { getFiles } from "apis/controllers/files";
import { getAvailableApartments, getChildInstitutes } from "apis/controllers/transfers";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { getTransfer } from "src/apis/controllers/transfers";
import { useLookup } from "src/context/lookupContext";
import { useLoading } from "src/hooks/useLoading";

const useTransferDetails = () => {
  const [data, setData] = useState(null);
  const [files, setFiles] = useState(null);
  const { id } = useParams();
  const { setLoading } = useLoading();
  const [succeeded, setSucceeded] = useState(false);
  const form = useForm();
  const expensesForm = useForm();
  const { setLookups } = useLookup();
  const [apartments, setApartments] = useState([]);

  const resetForm = async () => {
    try {
      setLoading(true);
      const res = await getTransfer(id);
      const resFiles = await getFiles({
        DataKey: "MHD_ChildTransfer",
        DataValue: null,
        RecordId: null,
        RecordGuid: id,
        ProjectTableId: 15,
      });
      setData(res?.data);
      setFiles(resFiles?.data);
      form.reset(res?.data?.application);
    } catch { }
    setLoading(false);
  };

  const fetchTransfer = async () => {
    try {
      setLoading(true);

      setData(null);
      setFiles(null);
      setSucceeded(false);
      const res = await getTransfer(id);
      const resFiles = await getFiles({
        DataKey: "MHD_ChildTransfer",
        DataValue: null,
        RecordId: null,
        RecordGuid: id,
        ProjectTableId: 15,
      });
      setFiles(resFiles?.data);
      let availableApartments;
      try {
        let apartmentsRes;
        if (res?.data?.application?.settings?.instituteSettings?.dataKey === 'Apartments') {
          apartmentsRes = await getAvailableApartments(res?.data?.application?.child?.id);
        }
        else if (res?.data?.application?.settings?.instituteSettings?.dataKey === 'ChildInstitutes') {
          apartmentsRes = await getChildInstitutes();
        }
        availableApartments = apartmentsRes?.data || [];
        setApartments(availableApartments);
      }


      catch (apartmentErr) {
        console.error('Error fetching available apartments:', apartmentErr);
        availableApartments = [];
      };
      form.reset({ ...res?.data?.application, selectedInstitute: res?.data?.application?.childInstitute });
      setData(res?.data);
      setLookups(res?.data?.lookups);
      setSucceeded(res?.succeeded);
    } catch { }
    setLoading(false);
  };


  useEffect(() => {
    fetchTransfer();
  }, []);

  return {
    form,
    expensesForm,
    data,
    succeeded,
    files,
    fetchTransfer,
    resetForm,
    apartments
  };
}

export default useTransferDetails;
